import { call, all } from "redux-saga/effects";

import { LoginActionWatcher } from "../containers/LoginContainer/saga";
import { ResetPwdActionWatcher } from "../containers/ForgotpasswordContainer/saga";
import { ResetOldPwdActionWatcher } from "../containers/ResetPwdContainer/saga";
import { feedbackActionWatcher } from "../containers/FeedbackContainer/saga";

import { CategoryActionWatcher } from "../containers/CategoryContainer/saga";

import { SignUpActionWatcher } from "../containers/SignUpContainer/saga";
import { DashboardActionWatcher } from "../containers/DashboardContainer/saga";
import { SupportActionWatcher } from "../containers/SupportContainer/saga";

import { OrdersActionWatcher } from "../containers/OrdersContainer/saga";
import { NormalOrdersActionWatcher } from "../containers/NormalOrdersContainer/saga";
import { OTPActionWatcher } from "../containers/OTPContainer/saga";
import { VerifyOTPActionWatcher } from "../containers/VerifyOTPContainer/saga";
import { createProfileActionWatcher } from "../containers/UpdateProfileContainer/saga";

import { MyProfileActionWatcher } from "../containers/MyProfileContainer/saga";
import { PurchaseReturnsActionWatcher } from "../containers/PurchaseReturnsContainer/saga";
import { ExpiryReturnsActionWatcher } from "../containers/ExpiryReturnsContainer/saga";
import { CreditNotesActionWatcher } from "../containers/CreditNotesContainer/saga";
import { PaymentActionWatcher } from "../containers/PaymentsContainer/saga";
import { InvoiceActionWatcher } from "../containers/InvoiceContainer/saga";
import { NotificationsActionWatcher } from "../containers/NotificationContainer/saga";
function* rootSaga() {
  yield all([
    call(LoginActionWatcher),
    call(OTPActionWatcher),
    call(VerifyOTPActionWatcher),
    call(feedbackActionWatcher),

    call(CategoryActionWatcher),
    call(ResetPwdActionWatcher),
    call(ResetOldPwdActionWatcher),
    call(createProfileActionWatcher),
    call(CreditNotesActionWatcher),
    call(SignUpActionWatcher),
    call(DashboardActionWatcher),
    call(OrdersActionWatcher),
    call(NormalOrdersActionWatcher),
    call(MyProfileActionWatcher),
    call(PurchaseReturnsActionWatcher),
    call(ExpiryReturnsActionWatcher),
    call(SupportActionWatcher),
    call(PaymentActionWatcher),
    call(InvoiceActionWatcher),
    call(NotificationsActionWatcher),
  ]);
}

export default rootSaga;
